import React from "react";
import styles from './PageHeading.module.scss'

export default function PageHeading({children, padding, textAlign}) {
    return <h1 className={styles.heading} style={{padding, textAlign}}>{children}</h1>
}